<div role="group" class="nimbus-duration-range-input-container" [formGroup]="form" (focusin)="onFocusIn()" (focusout)="onFocusOut($event)">
  <input
    #hours
    nimbusMatTimeNumber
    [lengthLimit]="2"
    [maxValue]="maxHours"
    class="hours"
    formControlName="hours"
    maxlength="2"
    (blur)="onBlur(form.controls.hours)"
    (input)="handleInput(form.controls.hours, minutes, 2)"
    (focus)="onFocus(hours)"
    (keyup.arrowRight)="autoFocusNext(form.controls.hours, minutes, 2)"
  />
  <span>:</span>
  <input
    #minutes
    nimbusMatTimeNumber
    [maxValue]="59"
    class="minutes"
    formControlName="minutes"
    maxlength="2"
    (blur)="onBlur(form.controls.minutes)"
    (input)="handleInput(form.controls.minutes, seconds, 2)"
    (focus)="onFocus(minutes)"
    (keyup.backspace)="autoFocusPrev(form.controls.minutes, hours)"
    (keyup.arrowLeft)="autoFocusPrev(form.controls.minutes, hours, true)"
    (keyup.arrowRight)="autoFocusNext(form.controls.minutes, seconds, 2)"
  />
  <span>:</span>
  <input
    #seconds
    nimbusMatTimeNumber
    [maxValue]="59"
    class="seconds"
    formControlName="seconds"
    maxlength="2"
    (blur)="onBlur(form.controls.seconds)"
    (input)="handleInput(form.controls.seconds)"
    (focus)="onFocus(seconds)"
    (keyup.backspace)="autoFocusPrev(form.controls.seconds, minutes)"
    (keyup.arrowLeft)="autoFocusPrev(form.controls.seconds, minutes, true)"
  />
</div>
